import { Injectable } from '@angular/core';

import { Subject, BehaviorSubject, Observable } from "rxjs";

@Injectable({ providedIn: 'root' })
export class ResponsiveService {
  private isMobile = new Subject();
  public screenWidth: string;

  constructor() {
    this.checkWidth();
  }

  private onMobileChange(status: boolean) {
    this.isMobile.next(status);
  }

  getMobileStatus(): Observable<any> {
    return this.isMobile.asObservable();
  }

  checkWidth() {
    var width = window.innerWidth;
    if (width <= 820) {
      this.screenWidth = 'sm';
      this.onMobileChange(true);
    }  else {
      this.screenWidth = 'lg';
      this.onMobileChange(false);
    }
  }
}